import React, { ReactElement } from 'react'
import { useAtomValue } from 'jotai'

import { BannerNotification } from '@mindfulchefuk/features/Notifications/components/BannerNotification'
import { getDiscountConfig } from '@mindfulchefuk/utils/getDiscountConfig'
import { voucherCodeAtom } from '@mindfulchefuk/store/onboarding'

export const OnboardingVoucherSuccessBanner = (): ReactElement => {
  const voucher = useAtomValue(voucherCodeAtom)

  const voucherConfig = getDiscountConfig(voucher)

  return (
    <BannerNotification
      variant="success"
      title={`Your discount code "${voucher}" has been applied`}
      id="success-voucher-applied"
      data-testid="success-voucher-applied"
    >
      {voucherConfig.totalDiscountSentence}
    </BannerNotification>
  )
}
